import {RootState} from '../../store';

// The slice stores the selected record keyed by id. Consumers expect a boolean
// map (`selection[id] === true`), which the selection hook derives from this.
export const selectionSelector = (state: RootState): Record<string, unknown> =>
    state['playbooks'].selection;
